import { useEffect, useState } from 'react'

const useIsMobile = (instanceId?: string): boolean => {
  const [current, setCurrent] = useState<boolean>(false)

  const handleChange = (e: CustomEvent): void => {
    if (instanceId) {
      e.detail.instanceId === instanceId && setCurrent(e.detail.value)
    } else {
      setCurrent(e.detail.value)
    }
  }

  useEffect(() => {
    document.addEventListener('retorik_isMobile', (e) => handleChange(e))
    // Dispatch event on mount to get the updated value in stead of the default one
    document.dispatchEvent(new Event('retorik_call_isMobile'))

    return () => {
      document.removeEventListener('retorik_isMobile', (e) => handleChange(e))
    }
  }, [])

  return current
}

export default useIsMobile
